class ScheduleTranslator {
  translateSchedules (schedulesResponse) {
    var translated = {
      schedules: [],
      locationSchedules: []
    };

    if (schedulesResponse === null) return translated;

    if ((schedulesResponse.A || null) !== null) {
      translated.schedules = schedulesResponse.A.map(x => this.translateSchedule(x));
    }

    if ((schedulesResponse.B || null) !== null) {
      translated.locationSchedules = schedulesResponse.B.map(x => this.translateLocationSchedule(x));
    }

    return translated;
  }

  translateLocationSchedule (locSchedule) {
    var result = {
      name: locSchedule.A,
      number: locSchedule.B,
      id: locSchedule.id
    };

    if ((locSchedule.C || null) !== null) {
      result.schedules = locSchedule.C.map(x => this.translateSchedule(x));
    }

    return result;
  }

  translateSchedule (schedule) {
    var result = {
      description: schedule.A,
      premium: schedule.B,
      deductible: schedule.C,
      limit: schedule.D,
      causeOfLoss: schedule.E,
      coinsurancePercent: schedule.F,
      maxItemValue: schedule.G,
      currentCoinsurance: schedule.H,
      valuation: schedule.L,
      id: schedule.id
    };

    if ((schedule.I || null) !== null) {
      result.scheduledItems = schedule.I.map(x => this.translateScheduledItem(x));
    }

    if ((schedule.J || null) !== null) {
      result.unscheduledItems = schedule.J.map(x => this.translateUnscheduledItem(x));
    }
    return result;
  }

  translateScheduledItem (scheduledItem) {
    return {
      description: scheduledItem.A,
      manufacturer: scheduledItem.B,
      model: scheduledItem.C,
      modelYear: scheduledItem.D,
      serialNumber: scheduledItem.E,
      limitOfInsurance: scheduledItem.F,
      premium: scheduledItem.G
    };
  }

  translateUnscheduledItem (unscheduledItem) {
    return {
      description: unscheduledItem.A,
      numberOfUnits: unscheduledItem.B,
      unitPrice: unscheduledItem.C,
      value: unscheduledItem.D,
      excluded: unscheduledItem.E
    };
  }
}

var x = new ScheduleTranslator();
export default x;
